module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/template/template.component.css
// module id = ./src/app/template/template.component.css
// module chunks = main